<template>
  <div>
    <SpanText xxsmall color="#666">powered by LeCHECK</SpanText>
  </div>
</template>

<script>
import SpanText from '@/components/_atoms/SpanText';

export default {
  name: 'PoweredByLeCHECK',
  components: {
    SpanText
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_molecules/PoweredByLeCHECK.vue